// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2rcDN","signatureBlock":"Footer_signatureBlock__23fXx","signature":"Footer_signature__1atxK"};